/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ErrorResponse = {
    error: ErrorResponse.error;
    message: string;
};
export namespace ErrorResponse {
    export enum error {
        BUSINESS_ERROR = 'BUSINESS_ERROR',
        USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
        WEAK_PASSWORD = 'WEAK_PASSWORD',
        ILLEGAL_RATING_VALUE = 'ILLEGAL_RATING_VALUE',
        MISSING_MEASUREMENT = 'MISSING_MEASUREMENT',
        INVALID_MEASUREMENT = 'INVALID_MEASUREMENT',
        MISSING_MEAL_RECOMMENDATIONS = 'MISSING_MEAL_RECOMMENDATIONS',
    }
}

